import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as affiliates_actions from '../redux-sagas/actions/affiliates';
import * as ageGroups_actions from '../redux-sagas/actions/ageGroups';
import * as entries_actions from '../redux-sagas/actions/entries';
import * as sponsors_actions from '../redux-sagas/actions/sponsors';
import * as tournament_actions from '../redux-sagas/actions/tournaments';
import * as medals_actions from '../redux-sagas/actions/medals';
import * as qas_actions from '../redux-sagas/actions/qas';
import * as contact_actions from '../redux-sagas/actions/contactEmailList';
import * as alumni_actions from '../redux-sagas/actions/alumni';
import * as hotels_actions from '../redux-sagas/actions/hotels';

import Main from '../components/layouts/base.blue.js';

function mapStateToProps(state) {
    return {
        sponsors: state.sponsors,
        sponsor: state.sponsor,
        affiliate: state.affiliate,
        affiliates: state.affiliates,
        alumni: state.alumni,
        alumnis: state.alumnis,
        medals: state.medals,
        medal: state.medal,
        ageGroups: state.ageGroups,
        hotels: state.hotels,
        hotel: state.hotel,
        entries: state.entries,
        tournaments: state.tournaments,
        tournament: state.tournament,
        seasonTypes: state.seasonTypes,
        qas: state.qas,
        qa: state.qa,
        qasCategories: state.qasCategories,
        contactEmailList: state.contactEmailList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        affiliatesActions: bindActionCreators(affiliates_actions, dispatch),
        ageGroupActions: bindActionCreators(ageGroups_actions, dispatch),
        entriesActions: bindActionCreators(entries_actions, dispatch),
        medalsActions: bindActionCreators(medals_actions, dispatch),
        qasActions: bindActionCreators(qas_actions, dispatch),
        sponsorsActions: bindActionCreators(sponsors_actions, dispatch),
        tournamentsActions: bindActionCreators(tournament_actions, dispatch),
        contactActions: bindActionCreators(contact_actions, dispatch),
        alumniActions: bindActionCreators(alumni_actions, dispatch),
        hotelsActions: bindActionCreators(hotels_actions, dispatch),
    }
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;



// WEBPACK FOOTER //
// ./src/apps/App.Admin.js